import { usePricesContext } from '@fff-web/fff-payments';
import { IPlanCode } from '../Interfaces';
import { useEffect, useState } from 'react';
import { OptimizelyDecision } from '@optimizely/react-sdk';
import { PlanCode } from '@fff-web/fff-payments/src/interfaces';
import { getPriceByPlanCode, getSeasonalPriceWithFeatureFlag } from '@fff-web/fff-utilities';

export interface Price {
  planCode: IPlanCode | PlanCode;
  price: number | undefined;
  annualPrice: number | undefined;
  save: number;
}

const INITIAL_STATE: Price = {
  planCode: IPlanCode.SEASONAL,
  price: 0,
  annualPrice: 0,
  save: 0,
};

// This hook retrieves the prices from localization-api in fff-payments
const useGetPricesByPlan = (flag?: OptimizelyDecision) => {
  const { prices, loading } = usePricesContext();
  const [seasonalPrice, setSeasonalPrice] = useState<Price>(INITIAL_STATE);
  const annualPrice: Price = getPriceByPlanCode(prices, IPlanCode.ANNUAL);

  useEffect(() => {
    if (loading) return;
    const newSeasonalPrice = getSeasonalPriceWithFeatureFlag(prices, flag, IPlanCode.SEASONAL);
    setSeasonalPrice(newSeasonalPrice as Price);
  }, [flag, prices, loading]);

  return {
    annualPrice,
    seasonalPrice,
    isLoadingPrices: loading,
  };
};

export default useGetPricesByPlan;
